import {formatDistanceToNow, parseISO} from 'date-fns'

import './index.css'

const CommentItem = props => {
  const {commentDetails, onDelete, onLikeButton} = props
  const {name, date, className, comment, id, isLiked} = commentDetails
  const postedTime = formatDistanceToNow(parseISO(date))

  const firstLetter = name[0].toUpperCase()
  const onDeleteItem = () => {
    onDelete(id)
  }

  const onClickLikeButton = () => {
    onLikeButton(id)
  }

  const isLikedImage = isLiked
    ? 'https://assets.ccbp.in/frontend/react-js/comments-app/liked-img.png'
    : 'https://assets.ccbp.in/frontend/react-js/comments-app/like-img.png'

  const likeClassName = isLiked ? 'liked-button' : 'like-button'

  return (
    <li className="comment-item-container">
      <div className="upper-container">
        <p className={className}>{firstLetter}</p>
        <div>
          <div className="post-container">
            <h1 className="item-head">{name}</h1>

            <p className="time">{postedTime} ago</p>
          </div>
          <p className="item-comment">{comment}</p>
        </div>
      </div>
      <div className="like-delete-container">
        <div className="like-container">
          <img src={isLikedImage} alt="like" />
          <button
            type="button"
            className={likeClassName}
            onClick={onClickLikeButton}
          >
            <p>Like</p>
          </button>
        </div>
        <button className="delete-button" type="button" onClick={onDeleteItem}>
          <img
            src="https://assets.ccbp.in/frontend/react-js/comments-app/delete-img.png "
            alt="delete"
          />
        </button>
      </div>
      <hr className="hr-line" />
    </li>
  )
}

export default CommentItem
